module.exports = __webpack_public_path__ + "media/images/new-24-white-ae7e177b381fee4e96e7ac6663733ee9.png";